/**
 * 可复用listView
 * 目前只支持上下滚动
 */
let ListView = xClass("ListView", ccui.ScrollView);

/**
 * delete需要实现的方法：
 *  delegate_getLength: ()=> number 获取列表总长度
 *  delegate_getItemHeight: (index)=> number 获取指定索引值子项高度
 *  delegate_renderItem: (index, view)=> view 渲染一个子视图，view为空时需要delegate自行构建一个新的子项。子项按照锚点(0, 1)设置坐标
 */
ListView.prototype.ctor = function (delegate) {
    let self = this;
    ccui.ScrollView.prototype.ctor.call(self);

    self.setDirection(ccui.ScrollViewDir.vertical);
    self.lastScrollY = self.getInnerContainerPosition().y;
    self.delegate = delegate;

    self.posList = [];
    self.ignoreUp = false;
    self.refresh();
}

ListView.prototype.onEnter = function () {
    let self = this;
    ccui.ScrollView.prototype.onEnter.call(self);
    // onEnter以后的第一次update跳过，这次update可能是因为changeSize引起的，会导致之前设置的滚动条位置不正确
    self.ignoreUp = true;
}

/**
 * 重置列表
 * @param focusIndex 默认展示位置
 * @param addInnerContainerHeight 额外长度 用于滚动后不想最后一个在最底部
 */
ListView.prototype.refresh = function (focusIndex = 0,addInnerContainerHeight) {
    let self = this;

    resetPos(self);

    let size = self.getContentSize();
    let innerHeight = Math.max(size.height, self.posList[self.posList.length - 1]);
    if (addInnerContainerHeight &&
        self.posList[self.posList.length - 1] > size.height) {
        innerHeight += addInnerContainerHeight
    }
    self.setInnerContainerSize(cc.size(size.width, innerHeight));

    let pos = self.posList[focusIndex];
    pos = self._contentSize.height - self._innerContainer.getContentSize().height + pos;
    if (pos > 0)
        pos = 0;
    self._jumpToDestination(self._innerContainer.getPositionX(), pos);

    updateViews(self, true);
}

// ListView.prototype.debugLayout = function(){
//     let self = this;


//     let pos1 = self._innerContainer.convertToWorldSpace(cc.p(0, 0));
//     let pos2 = self._innerContainer.convertToWorldSpace(cc.p(self._innerContainer.getContentSize().width, self._innerContainer.getContentSize().height));

//     if (!self.debugNode) {
//     let node = cc.LayerColor.create(cc.color(255,0,0,100))
//     node.setPosition(pos1);
//     node.setContentSize(pos2.x - pos1.x, pos2.y - pos1.y);
//     cc.Director.getInstance().getRunningScene().addChild(node, 99999)
//     self.debugNode = node;
//     }else {
//         self.debugNode.setPosition(pos1);
//         self.debugNode.setContentSize(pos2.x - pos1.x, pos2.y - pos1.y);
//     }

// }

ListView.prototype.cleanup = function () {
    let self = this;

    self.delegate = null;
    ccui.ScrollView.prototype.cleanup.call(self);
}

ListView.prototype.update = function (dt) {
    let self = this;
    ccui.ScrollView.prototype.update.call(this, dt);

    updateViews(self);
}

function updateViews(self, forceAll) {
    if (self.ignoreUp) {
        self.ignoreUp = false;
        self._jumpToDestination(self._innerContainer.getPositionX(), self.lastScrollY);
        return;
    }

    let curScrollY = self.getInnerContainerPosition().y;
    if (!forceAll && curScrollY === self.lastScrollY) {
        return;
    }
    
    let top = self.getContentSize().height - curScrollY, bottom = -curScrollY;
    let topIndex = 0, showCount = 0, innerHeight = self.getInnerContainerSize().height;
    for (let i = 0; i < self.posList.length - 1; i++) {
        if (innerHeight - self.posList[i + 1] >= top) {
            continue;
        } else if (innerHeight - self.posList[i] <= bottom) {
            break;
        } else {
            if (showCount === 0)
                topIndex = i;
            showCount++;
        }
    }
    
    if (forceAll || showCount === 0) {
        fullAllChildren(self, topIndex, showCount, innerHeight);
    } else {
        let topOutList = [], bottomOutList = [], unVisibleList = [];
        let reuseMap = {};
        let child = null, children = self.getChildren(), reuseCount = 0;
        for (let i = 0; i < children.length; i++) {
            child = children[i];
            if (child.idx === -1) {
                unVisibleList.push(child);
                child.setVisible(false);
            } else if (child.idx < topIndex) {
                topOutList.splice(0, 0, child); // qq上没有reverse方法 -_-!
                child.setVisible(false);
            } else if (child.idx > topIndex + showCount - 1) {
                bottomOutList.push(child);
                child.setVisible(false);
            } else {
                reuseMap[child.idx] = child;
                child.setVisible(true);
                reuseCount++;
            }
        }

        if (reuseCount < showCount) {
            if (curScrollY > self.lastScrollY) {
                // 向下滚，优先使用底部不可见内容填充
                unVisibleList = topOutList.concat(bottomOutList, unVisibleList);
            } else {
                // 向上滚，优先使用顶部不可见内容填充
                unVisibleList = bottomOutList.concat(topOutList, unVisibleList);
            }

            // 填充未被复用的组件
            for (let i = topIndex; i < topIndex + showCount; i++) {
                if (!reuseMap[i]) {
                    child = unVisibleList.pop();
                    fullChild(self, child, i, innerHeight);
                }
            }
            self.sortAllChildren();
        }
    }

    self.lastScrollY = self.getInnerContainerPosition().y;
}

function fullAllChildren(self, topIndex, showCount, innerHeight) {
    let child = null, children = self.getChildren();
    for (let i = 0; i < showCount; i++) {
        child = children[i];
        fullChild(self, child, i + topIndex, innerHeight);
    }
    for (let i = showCount; i < children.length; i++) {
        child = children[i];
        child.idx = -1;
        child.setVisible(false);
    }
    self.sortAllChildren();
}

function fullChild(self, child, i, innerHeight) {
    if (child)
        child.setVisible(true);
    child = self.delegate.delegate_renderItem.call(self.delegate, i, child);
    child.idx = i;
    child.setLocalZOrder(i);
    if (child.getParent() == null) {
        self.addChild(child);
    }
    child.setAnchorPoint(0, 1);
    child.setPosition(0, innerHeight - self.posList[i]);
}

/**
 * 计算全部节点的位置信息
 */
function resetPos(self) {
    self.posList.length = 0;

    if (self.delegate) {
        let count = self.delegate.delegate_getLength.call(self.delegate);

        let pos = 0;
        for (let i = 0; i < count; i++) {
            self.posList.push(pos);
            pos = pos + self.delegate.delegate_getItemHeight.call(self.delegate, i);
        }
        self.posList.push(pos);
    }
}


module.exports = ListView
